import fetch from 'utils/fetch';
import { serializeTip } from 'tip/utils/serialize';

export const REQUEST_TIP = 'REQUEST_TIP';
export const RECEIVE_TIP = 'RECEIVE_TIP';
export const TIP_RECEIVE_FAILED = 'TIP_RECEIVE_FAILED';

export const SAVING_TIP = 'SAVING_TIP';
export const TIP_SAVE_FAILED = 'TIP_SAVE_FAILED';
export const TIP_SAVED = 'TIP_SAVED';

function requestTip(tip) {
  return {
    type: REQUEST_TIP,
    payload: {
      tip,
    },
  };
}

function receiveTip(tip) {
  return {
    type: RECEIVE_TIP,
    payload: {
      tip,
    },
  };
}

function receiveFailed(error) {
  return {
    type: TIP_RECEIVE_FAILED,
    payload: {
      error,
    },
  };
}

function savingTip(tip) {
  return {
    type: SAVING_TIP,
    payload: {
      tip,
    },
  };
}

function saveFailed(error) {
  return {
    type: TIP_SAVE_FAILED,
    payload: {
      error,
    },
  };
}

function fetchTip(tip) {
  return dispatch => {
    dispatch(requestTip(tip));
    fetch(`/tips.json/${tip}`)
      .then(r => r.json())
      .then(tip => dispatch(receiveTip(tip)))
      .catch(error => dispatch(receiveFailed(error)));
  };
}

function shouldFetchTip(state) {
  const tip = state.tips.tip;
  if (!tip.tip) {
    return true;
  } else if (tip.isFetching) {
    return false;
  }

  return tip.didInvalidate;
}

export function fetchTipIfNeeded(tip) {
  return (dispatch, getState) => {
    if (shouldFetchTip(getState())) {
      dispatch(fetchTip(tip));
    }
  };
}

export function saveTip(id, page, fields) {
  return (dispatch, getState) => {
    const state = getState().tips;
    const tipAsMultipart = serializeTip(state, fields);

    dispatch(savingTip(id));
    return fetch(`/tips.json/${id}?page=${page}`, {
      method: 'post',
      body: tipAsMultipart,
    })
      .then(res => res.json())
      .then(updated => dispatch(receiveTip(updated)))
      .catch(error => dispatch(saveFailed(error)));
  };
}



// WEBPACK FOOTER //
// ./src/modules/tip/actions/tip.js